// @generated by protoc-gen-es v2.14.1 with parameter "target=ts"
// @generated from file travplaces/v1/places.proto (package travplaces.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_travplaces_v1_audit } from "./audit_pb";
import { file_travplaces_v1_authz } from "./authz_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file travplaces/v1/places.proto.
 */
export const file_travplaces_v1_places: GenFile = /*@__PURE__*/
  fileDesc("Chp0cmF2cGxhY2VzL3YxL3BsYWNlcy5wcm90bxINdHJhdnBsYWNlcy52MSIzChVTZWFyY2hFeHRlcm5hbFJlcXVlc3QSDwoHY2l0eV9pZBgBIAEoCRIJCgFxGAIgASgJIkEKFlNlYXJjaEV4dGVybmFsUmVzcG9uc2USEQoJYXZhaWxhYmxlGAEgASgIEhQKDHJlc3VsdHNfanNvbhgCIAEoCSJBChREZXNjcmliZVBsYWNlUmVxdWVzdBIPCgdjaXR5X2lkGAEgASgJEgsKA2xhdBgCIAEoARILCgNsbmcYAyABKAEiPQoVRGVzY3JpYmVQbGFjZVJlc3BvbnNlEhMKC2Rlc2NyaXB0aW9uGAEgASgJEg8KB2FkZHJlc3MYAiABKAkiPQoOR2VvY29kZVJlcXVlc3QSCQoBcRgBIAEoCRIPCgdjb3VudHJ5GAIgASgJEg8KB2ZlYXR1cmUYAyABKAkiJwoPR2VvY29kZVJlc3BvbnNlEhQKDHJlc3VsdHNfanNvbhgBIAEoCSI2ChhTZWFyY2hQbGFjZXNUb0FkZFJlcXVlc3QSDwoHY2l0eV9pZBgBIAEoCRIJCgFxGAIgASgJIlQKGVNlYXJjaFBsYWNlc1RvQWRkUmVzcG9uc2USEQoJYXZhaWxhYmxlGAEgASgIEg4KBnJlYXNvbhgCIAEoCRIUCgxyZXN1bHRzX2pzb24YAyABKAky5AEKDVBsYWNlc1NlcnZpY2USagoOU2VhcmNoRXh0ZXJuYWwSJC50cmF2cGxhY2VzLnYxLlNlYXJjaEV4dGVybmFsUmVxdWVzdBolLnRyYXZwbGFjZXMudjEuU2VhcmNoRXh0ZXJuYWxSZXNwb25zZSILiuowAwoBIJDqMAESZwoNRGVzY3JpYmVQbGFjZRIjLnRyYXZwbGFjZXMudjEuRGVzY3JpYmVQbGFjZVJlcXVlc3QaJC50cmF2cGxhY2VzLnYxLkRlc2NyaWJlUGxhY2VSZXNwb25zZSILiuowAwoBIJDqMAEy4QEKE0FkbWluR2VvY29kZVNlcnZpY2USVQoHR2VvY29kZRIdLnRyYXZwbGFjZXMudjEuR2VvY29kZVJlcXVlc3QaHi50cmF2cGxhY2VzLnYxLkdlb2NvZGVSZXNwb25zZSILiuowAwoBIJDqMAEScwoRU2VhcmNoUGxhY2VzVG9BZGQSJy50cmF2cGxhY2VzLnYxLlNlYXJjaFBsYWNlc1RvQWRkUmVxdWVzdBooLnRyYXZwbGFjZXMudjEuU2VhcmNoUGxhY2VzVG9BZGRSZXNwb25zZSILiuowAwoBIJDqMAFCpgEKEWNvbS50cmF2cGxhY2VzLnYxQgtQbGFjZXNQcm90b1ABWi90cmF2cGxhY2VzL2dlbi9wcm90by90cmF2cGxhY2VzL3YxO3RyYXZwbGFjZXN2MaICA1RYWKoCDVRyYXZwbGFjZXMuVjHKAg1UcmF2cGxhY2VzXFYx4gIZVHJhdnBsYWNlc1xWMVxHUEJNZXRhZGF0YeoCDlRyYXZwbGFjZXM6OlYxYgZwcm90bzM", [file_travplaces_v1_audit, file_travplaces_v1_authz]);

/**
 * @generated from message travplaces.v1.SearchExternalRequest
 */
export type SearchExternalRequest = Message<"travplaces.v1.SearchExternalRequest"> & {
  /**
   * @generated from field: string city_id = 1;
   */
  cityId: string;

  /**
   * @generated from field: string q = 2;
   */
  q: string;
};

/**
 * Describes the message travplaces.v1.SearchExternalRequest.
 * Use `create(SearchExternalRequestSchema)` to create a new message.
 */
export const SearchExternalRequestSchema: GenMessage<SearchExternalRequest> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_places, 0);

/**
 * @generated from message travplaces.v1.SearchExternalResponse
 */
export type SearchExternalResponse = Message<"travplaces.v1.SearchExternalResponse"> & {
  /**
   * @generated from field: bool available = 1;
   */
  available: boolean;

  /**
   * JSON array of ExternalPlace objects:
   * {id, name, address, lat, lng, source}.
   *
   * @generated from field: string results_json = 2;
   */
  resultsJson: string;
};

/**
 * Describes the message travplaces.v1.SearchExternalResponse.
 * Use `create(SearchExternalResponseSchema)` to create a new message.
 */
export const SearchExternalResponseSchema: GenMessage<SearchExternalResponse> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_places, 1);

/**
 * @generated from message travplaces.v1.DescribePlaceRequest
 */
export type DescribePlaceRequest = Message<"travplaces.v1.DescribePlaceRequest"> & {
  /**
   * @generated from field: string city_id = 1;
   */
  cityId: string;

  /**
   * @generated from field: double lat = 2;
   */
  lat: number;

  /**
   * @generated from field: double lng = 3;
   */
  lng: number;
};

/**
 * Describes the message travplaces.v1.DescribePlaceRequest.
 * Use `create(DescribePlaceRequestSchema)` to create a new message.
 */
export const DescribePlaceRequestSchema: GenMessage<DescribePlaceRequest> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_places, 2);

/**
 * @generated from message travplaces.v1.DescribePlaceResponse
 */
export type DescribePlaceResponse = Message<"travplaces.v1.DescribePlaceResponse"> & {
  /**
   * JSON PlaceDescription object: {name, address, source, lat, lng}.
   *
   * @generated from field: string description = 1;
   */
  description: string;

  /**
   * The same address, duplicated as a plain field for callers that only
   * need it (the description JSON already carries it too).
   *
   * @generated from field: string address = 2;
   */
  address: string;
};

/**
 * Describes the message travplaces.v1.DescribePlaceResponse.
 * Use `create(DescribePlaceResponseSchema)` to create a new message.
 */
export const DescribePlaceResponseSchema: GenMessage<DescribePlaceResponse> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_places, 3);

/**
 * @generated from message travplaces.v1.GeocodeRequest
 */
export type GeocodeRequest = Message<"travplaces.v1.GeocodeRequest"> & {
  /**
   * @generated from field: string q = 1;
   */
  q: string;

  /**
   * ISO 3166-1 alpha-2, lowercase. Empty searches everywhere.
   *
   * @generated from field: string country = 2;
   */
  country: string;

  /**
   * "city" | "state" | "settlement" | "" (anything with a boundary).
   *
   * @generated from field: string feature = 3;
   */
  feature: string;
};

/**
 * Describes the message travplaces.v1.GeocodeRequest.
 * Use `create(GeocodeRequestSchema)` to create a new message.
 */
export const GeocodeRequestSchema: GenMessage<GeocodeRequest> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_places, 4);

/**
 * @generated from message travplaces.v1.GeocodeResponse
 */
export type GeocodeResponse = Message<"travplaces.v1.GeocodeResponse"> & {
  /**
   * JSON array of GeocodedPlace objects:
   * {displayName, kind, bbox: [minLng,minLat,maxLng,maxLat], lat, lng}.
   *
   * @generated from field: string results_json = 1;
   */
  resultsJson: string;
};

/**
 * Describes the message travplaces.v1.GeocodeResponse.
 * Use `create(GeocodeResponseSchema)` to create a new message.
 */
export const GeocodeResponseSchema: GenMessage<GeocodeResponse> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_places, 5);

/**
 * @generated from message travplaces.v1.SearchPlacesToAddRequest
 */
export type SearchPlacesToAddRequest = Message<"travplaces.v1.SearchPlacesToAddRequest"> & {
  /**
   * @generated from field: string city_id = 1;
   */
  cityId: string;

  /**
   * @generated from field: string q = 2;
   */
  q: string;
};

/**
 * Describes the message travplaces.v1.SearchPlacesToAddRequest.
 * Use `create(SearchPlacesToAddRequestSchema)` to create a new message.
 */
export const SearchPlacesToAddRequestSchema: GenMessage<SearchPlacesToAddRequest> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_places, 6);

/**
 * @generated from message travplaces.v1.SearchPlacesToAddResponse
 */
export type SearchPlacesToAddResponse = Message<"travplaces.v1.SearchPlacesToAddResponse"> & {
  /**
   * @generated from field: bool available = 1;
   */
  available: boolean;

  /**
   * "no_key" | "disabled" (reserved for a future config toggle) — empty when
   * available is true.
   *
   * @generated from field: string reason = 2;
   */
  reason: string;

  /**
   * JSON array of AdminPlaceResult objects:
   * {id, name, address, lat, lng, rating, ratingCount, website, phone,
   *  primaryType, businessStatus, existing, suggestedCategoryId}.
   *
   * @generated from field: string results_json = 3;
   */
  resultsJson: string;
};

/**
 * Describes the message travplaces.v1.SearchPlacesToAddResponse.
 * Use `create(SearchPlacesToAddResponseSchema)` to create a new message.
 */
export const SearchPlacesToAddResponseSchema: GenMessage<SearchPlacesToAddResponse> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_places, 7);

/**
 * PlacesService searches an external place provider (Google Places), on top
 * of the local OpenStreetMap-derived database. The local database stays
 * authoritative for routing; this exists only to help someone find a place
 * OSM does not name well. Nothing returned here is written to the database —
 * a chosen result becomes a plain coordinate stop.
 *
 * @generated from service travplaces.v1.PlacesService
 */
export const PlacesService: GenService<{
  /**
   * SearchExternal searches the external provider within a city's bounding
   * box. `available` is false when no provider key is configured (or the
   * provider call failed); in that case results_json is "[]".
   *
   * @generated from rpc travplaces.v1.PlacesService.SearchExternal
   */
  searchExternal: {
    methodKind: "unary";
    input: typeof SearchExternalRequestSchema;
    output: typeof SearchExternalResponseSchema;
  },
  /**
   * DescribePlace names whatever is at a coordinate, for labelling a pin
   * dropped on the map.
   *
   * @generated from rpc travplaces.v1.PlacesService.DescribePlace
   */
  describePlace: {
    methodKind: "unary";
    input: typeof DescribePlaceRequestSchema;
    output: typeof DescribePlaceResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_travplaces_v1_places, 0);

/**
 * AdminGeocodeService is the admin-only pairing of a boundary lookup (for
 * setting up a new city) and a provider search that shows what we already
 * hold beside each candidate result.
 *
 * @generated from service travplaces.v1.AdminGeocodeService
 */
export const AdminGeocodeService: GenService<{
  /**
   * Geocode looks up a place's bounding box and administrative boundary via
   * Nominatim (OpenStreetMap's own geocoder) — no key required.
   *
   * @generated from rpc travplaces.v1.AdminGeocodeService.Geocode
   */
  geocode: {
    methodKind: "unary";
    input: typeof GeocodeRequestSchema;
    output: typeof GeocodeResponseSchema;
  },
  /**
   * SearchPlacesToAdd searches the external provider for a place to add by
   * hand, admin-detail shape (rating, website, phone, ...).
   *
   * @generated from rpc travplaces.v1.AdminGeocodeService.SearchPlacesToAdd
   */
  searchPlacesToAdd: {
    methodKind: "unary";
    input: typeof SearchPlacesToAddRequestSchema;
    output: typeof SearchPlacesToAddResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_travplaces_v1_places, 1);

